
function scrollFunction() {
	if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
		jQuery("body").addClass("bm-Header--Not-Top");
	} else {
		jQuery("body").removeClass("bm-Header--Not-Top");
	}
}

window.addEventListener('scroll', scrollFunction);
